module.exports = __webpack_public_path__ + "img/value-added.3e3a9df5.jpg";